import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import TextField from '@mui/material/TextField';

const AdditionalDetails = props => {
    
    const handleAdditionalDetailsChange = event => {
        props.setAdditionalDetails(event.target.value);
    };

    return (
        <div id="callReasonSubValues">
        <div id="pageTitle">
            <p className="surveyHeading fs-unmask">
            ADDITIONAL DETAILS (OPTIONAL)
            </p>
            <p className="surveyInfo fs-unmask">
                If there&apos;s additional information you&apos;d like to provide, capture it below  or simply just click Next to continue.
            </p>
            <hr className="hr" />
        </div>
        <div
          id="acc"
          style={{
            paddingBottom: '10px',
            paddingLeft: '20px',
            paddingRight: '20px',
          }}
        >
              <FormGroup sx={{ m: 3 }} component="fieldset" variant="standard" className="fs-unmask">
                <TextField
                  id="additionalDetails"
                  name="additionalDetails"
                  label="ADDITIONAL DETAILS"
                  variant="outlined"
                  multiline
                  rows={4}
                  inputProps={{maxLength: 2500}}
                  onChange={handleAdditionalDetailsChange}
                  value={props.additionalDetails}
                  className="fs-unmask"
                />
              </FormGroup>
        </div>
        <div
            id="buttonContainer"
            style={{ background: 'white' }}
            className="buttonContainer"
        >
            <hr className="hr" />
            <Stack spacing={2} direction="row">
            <Button
                id="backButton"
                variant="outlined"
                style={{
                borderRadius: '20px',
                opacity: 1,
                marginBottom: '10px',
                width: '40%',
                left: '10%',
                }}
                onClick={props.summaryBack}
                className="fs-unmask"
            >
                Back
            </Button>
            <Button
                id="nextButton"
                variant="contained"
                style={{
                background: '#127CB7',
                borderRadius: '20px',
                opacity: 1,
                marginBottom: '10px',
                width: '40%',
                left: '10%',
                }}
                onClick={props.next}
                className="fs-unmask"
            >
                Next
            </Button>
            </Stack>
        </div>
        </div>
    )
};

AdditionalDetails.propTypes = {
    setAdditionalDetails: PropTypes.func.isRequired,
    additionalDetails: PropTypes.string.isRequired,
    summaryBack: PropTypes.func.isRequired,
    next: PropTypes.func.isRequired,
};

export default AdditionalDetails;